export const CHANNEL_LABELS = {
  paid_search: 'Paid Search',
  paid_social: 'Paid Social',
  display: 'Display Ads',
  organic_search: 'Organic Search',
  organic_social: 'Organic Social',
  email: 'Email',
  referral: 'Other Websites',
  other: 'Other',
  direct: 'Direct or not tracked'
};
